<template>
  <v-dialog v-model="dialog" width="300" @input="onClick()">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="placeholder"
        v-mask="'####-##-##'"
        :label="`${label} (yyyy-mm-dd)`"
        v-bind="attrs"
        :rules="rules"
        :data-cy="dataCy"
        @input="(val) => $emit('input', val)"
      >
        <template v-slot:prepend>
          <v-icon :data-cy="`${dataCy}-icon`" v-on="on"> mdi-calendar </v-icon>
        </template>
      </v-text-field>
    </template>
    <div>
      <v-date-picker
        ref="picker"
        v-model="placeholder"
        :max="max"
        :min="min"
        style="border-radius: 0; width: 100%"
        @input="(val) => $emit('input', val)"
      />
      <v-btn
        style="border-radius: 0; width: 100%"
        :data-cy="`${dataCy}-button-submit`"
        @click="dialog = false"
      >
        Done
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
import { DateTime } from "luxon";

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    birthday: {
      type: Boolean,
    },
    yearFirst: {
      type: Boolean,
    },
    dataCy: {
      type: String,
      default: null,
    },
    futureOnly: {
      type: Boolean,
    },
  },
  data() {
    return {
      dialog: false,
      max: null,
      min: null,
      rules: [
        (val) =>
          DateTime.fromFormat(val, "yyyy-MM-dd").isValid ||
          "Must be a valid datetime.",
      ],
    };
  },
  computed: {
    placeholder: {
      set() {
        return this.value;
      },
      get() {
        return this.value;
      },
    },
  },
  methods: {
    onClick() {
      this.$nextTick(() => {
        if (this.yearFirst) {
          this.$refs.picker.activePicker = "YEAR";
        }
        if (this.birthday) {
          this.max = DateTime.local()
            .minus({ year: 16 })
            .toFormat("yyyy-MM-dd");
        }
        if (this.futureOnly) {
          this.min = DateTime.local().toFormat("yyyy-MM-dd");
        }
      });
    },
  },
};
</script>

<style>
</style>
